import { FormApi } from "@tanstack/form-core";
import { useStore } from "@tanstack/vue-store";
import { defineComponent, h, onMounted } from "vue";
import { Field, useField } from "./useField.js";
function useForm(opts) {
  const formApi = (() => {
    const api = new FormApi(opts);
    const extendedApi = api;
    extendedApi.Field = defineComponent(
      (props, context) => {
        return () => h(
          Field,
          { ...props, ...context.attrs, form: api },
          context.slots
        );
      },
      {
        name: "APIField",
        inheritAttrs: false
      }
    );
    extendedApi.useField = (props) => {
      const field = useField({ ...props, form: api });
      return field;
    };
    extendedApi.useStore = (selector) => {
      return useStore(api.store, selector);
    };
    extendedApi.Subscribe = defineComponent(
      (props, context) => {
        const allProps = { ...props, ...context.attrs };
        const selector = allProps.selector ?? ((state) => state);
        const data = useStore(api.store, selector);
        return () => context.slots.default(data.value);
      },
      {
        name: "Subscribe",
        inheritAttrs: false
      }
    );
    return extendedApi;
  })();
  onMounted(formApi.mount);
  formApi.update(opts);
  return formApi;
}
export {
  useForm
};
//# sourceMappingURL=useForm.js.map
